
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/pomoc/faq",
      function () {
        return require("private-next-pages/moje-konto/pomoc/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/pomoc/faq"])
      });
    }
  